
import './App.css';
import Portfolio from './Portofolio';
import InstallPrompt from "./InstallPrompt";


function App() {
  return (
   <>

    <Portfolio/>
     <InstallPrompt />
   </>
  );
}

export default App;
